module.exports = __webpack_public_path__ + "static/media/Itp.7d194061.jpg";